<div class="d-flex align-items-center justify-content-between">
    <div [innerHtml]="content.DarkModeText"></div>
    <ds-switch [checked]="service.isEnabled" (checkedChange)="toggleDarkMode()" />
</div>
